import { useRouter } from "next/router";
import { useEffect } from "react";
import * as NProgress from "./nprogress";
import routes from "./routes";
import { PersistentStorage } from "./services/persistentStorage";

export const useRouterEvents = () => {
	const router = useRouter();

	useEffect(() => {
		const beforeUnloadHandler = () => {
			NProgress.end();
		};

		const routeChangeStartHandler = (path) => {
			if (path.indexOf(routes.purchaseBase) !== 0) {
				PersistentStorage().billingInfo.clear();
			}

			NProgress.start();
		};

		const routeChangeErrorHandler = () => {
			NProgress.end();
		};

		const routeChangeCompleteHandler = (path) => {
			global.scrollTo(0, 0);

			NProgress.end();

			if (path !== routes.auth.logout) {
				const isAction = path.includes("action=");
				if (!isAction) {
					global.dataLayer.push({ event: "Returned Page" });
				}
			}
		};

		router.events.on("routeChangeStart", routeChangeStartHandler);
		router.events.on("routeChangeError", routeChangeErrorHandler);
		router.events.on("routeChangeComplete", routeChangeCompleteHandler);
		window.addEventListener("beforeunload", beforeUnloadHandler);

		return () => {
			router.events.off("routeChangeStart", routeChangeStartHandler);
			router.events.off("routeChangeError", routeChangeErrorHandler);
			router.events.off("routeChangeComplete", routeChangeCompleteHandler);
			window.removeEventListener("beforeunload", beforeUnloadHandler);
		};
	}, [router]);
};
